module.exports = __webpack_public_path__ + "img/cameroon.a72fdb01.svg";